module.exports = __webpack_public_path__ + "static/media/coming_soon.5436c28b.png";